<template>
  <div id="numberQuestionBar">
    <div class="columns">
      <div class="column is-8 is-offset-2 is-relative" style="position:relative">
        <div id="tagImage">
          <figure class="image">
            <img src="/images/numberTagAndBee.png">
          </figure>
          <div id="nextTextBox">
            {{ transformNumberQuestionToLocaleString(nextText, numberLocale) }}
          </div>
          <div id="textBox" :class="{'has-text-danger': correctText != ''}">
            {{ transformNumberQuestionToLocaleString(text, numberLocale) }}
          </div>
        </div>
        <div id="correctTextBox" class="has-text-danger">
          {{ transformNumberQuestionToLocaleString(correctText, numberLocale) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { transformNumberQuestionToLocaleString } from '@/edshed-common/api'
import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class NumberQuestionBar extends Vue {
  @Prop(String) readonly text!: string;
  @Prop(String) readonly nextText!: string;
  @Prop(String) readonly correctText!: string;

  get numberLocale (): string {
    if (!this.$store.state || !this.$store.state.user || !this.$store.state.user.school || !this.$store.state.user.school.locale) { return 'en-gb' }
    return this.$store.state.user.school.locale.replace('_', '-')
  }

  transformNumberQuestionToLocaleString = transformNumberQuestionToLocaleString
}
</script>
<style scoped>
  #wordPreview {
    margin-top: 10px;
  }

  #tagImage {
    padding: 0 20px;
    position: relative;
    max-width: 768px;
    margin: 0 auto;
  }

  #nextTextBox {
    position: absolute;
    width: 75%;
    height: 20%;
    font-size: 2em;
    top: 12%;
    left: 10%;
    font-family: var(--user-chosen-font);
    text-align: center;
    color: #757575;
  }

  #textBox {
    position: absolute;
    width: 75%;
    height: 40%;
    font-size: 4em;
    top: 26%;
    left: 10%;
    font-family: var(--user-chosen-font);
    text-align: center;
  }

  #correctTextBox {
    position: absolute;
    width: 75%;
    height: 20%;
    font-size: 2em;
    bottom: 15%;
    left: 12%;
    font-family: var(--user-chosen-font);
    text-align: center;
  }

  @media all and (max-width: 768px) {
    #textBox {
      font-size: 3em;
    }

    #nextTextBox {
      font-size: 1.5em;
    }

    #correctTextBox {
      font-size: 1.5em;
    }
  }
</style>
